export const elmoExperimentResourceNames = {
  default: 'GOPS_smarthelp',
  pcc: 'GOPS_smarthelp_pcc',
  kmSearch: 'GOPS_smarthelp_km_search',
  nnaDesign: 'CustomerSupport:NNAExperiances',
  nativeMessagingExperience: 'GOPS_smarthelp_native_messaging_in_venice',
  searchLimiterResourceName: 'GOPS_smarthelp_Search_Limiter_Exp',
  contactUsVerbiageResourceName: 'GOPS_smarthelp_contactus_mc_verbiage',
  resolutionCenterResource: 'helpcenter_mobile',
  callUsGuestResource: 'GOPS_smarthelp_guest_call_us_link',
  whiteBannerChatBotResourceName: 'chatbotRamp',
  ipsNewDesign: 'GOPS_smarthelp_IPS_Design',
};

export const elmoTreatmentNames = {
  nnaEnabled: 'Trmt_CustomerSupportR_NNAExperiances_By_Channel',
  nativeMessagingEnabled: 'Trmt_GOPS_Helpcenter_Native_Messaging_In_Venice_Enabled',
  searchLimiterTreatmentName: 'Trmt_GOPS_Helpcenter_Search_Limiter_Exp',
  messageCenterLinkShowExp: 'Trmt_GOPS_Helpcenter_MC_link',
  messageCenterContactCardExp: 'Trmt_GOPS_Helpcenter_MC_verbiage',
  messageCenterContactUsVerbiageExp: 'Trmt_GOPS_Helpcenter_ContactUs_MC_Verbiage',
  resolutionCenterExp: 'Trmt_Helpcenter_Home_Resolution_Center_Card',
  callUsGuestExp: 'Trmt_GOPS_Helpcenter_Guest_Call_Us_Link',
  whiteBannerChatBotExp: 'Trmt_GOPS_Helpcenter_White_Banner_Bot',
  ipsNewDesignTreatment: 'Trmt_GOPS_Helpcenter_IPS_Contexual_Help_design',
  chatBotAssistantShortMessageExp: 'Trmt_GOPS_Helpcenter_Chatbot_Assistant_Short_Msg',
  chatBotAssistantLongMessageExp: 'Trmt_GOPS_Helpcenter_Chatbot_Assistant_Long_Msg',
};

export const isPartOfElmoExpTreatment = (elmoTreatments, treatmentName) =>
  Array.isArray(elmoTreatments) && elmoTreatments.indexOf(treatmentName) >= 0;
